module.exports = __webpack_public_path__ + "static/media/city-of-london-logo.33ba8bf4.svg";